(function () {
  const STORAGE_KEY = 'wc_crux_journal_access_v1';
  const ADMIN_STORAGE_KEY = 'wc_crux_admin_access_v1';
  const MAX_AGE = 365 * 24 * 60 * 60 * 1000;
  const GUIDE_HOST = 'guide.weathercraft.com.au';
  const ADMIN_EMAIL = 'raquel@weathercraft.com.au';

  function getAccessHash() {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!saved || !saved.hash) return '';
      const hash = String(saved.hash).toLowerCase();
      const age = Date.now() - Number(saved.validatedAt || 0);
      if (!/^[a-f0-9]{64}$/.test(hash) || age < 0 || age > MAX_AGE) return '';
      return hash;
    } catch (e) {
      return '';
    }
  }

  function getRoot() {
    return document.querySelector('[data-wc-crux-root]');
  }

  function loadAudio(root) {
    root.querySelectorAll('audio[data-wc-audio-src]').forEach(function (audio) {
      if (audio.dataset.loaded === 'true') return;
      const source = document.createElement('source');
      source.src = audio.dataset.wcAudioSrc;
      source.type = 'audio/mpeg';
      audio.appendChild(source);
      audio.dataset.loaded = 'true';
      audio.load();
    });
  }

  function showAdmin() {
    const root = getRoot();
    if (!root) return;
    const login = root.querySelector('[data-wc-crux-login]');
    const validation = root.querySelector('[data-wc-crux-validation]');
    const member = root.querySelector('[data-wc-crux-member]');
    const denied = root.querySelector('[data-wc-crux-denied]');
    const memberType = root.querySelector('[data-wc-crux-member-type]');
    [login, validation, member, denied].forEach(function (el) {
      if (!el) return;
      el.hidden = el !== member;
    });
    if (member) member.removeAttribute('inert');
    if (memberType) memberType.textContent = 'Weathercraft admin';
    loadAudio(root);
  }

  function saveAdminAccess() {
    try { localStorage.setItem(ADMIN_STORAGE_KEY, JSON.stringify({ validatedAt: Date.now() })); } catch (e) {}
  }

  function clearAdminAccess() {
    try { localStorage.removeItem(ADMIN_STORAGE_KEY); } catch (e) {}
  }

  function restoreAdminAccess() {
    try {
      const saved = JSON.parse(localStorage.getItem(ADMIN_STORAGE_KEY) || 'null');
      if (!saved) return false;
      const age = Date.now() - Number(saved.validatedAt || 0);
      if (age < 0 || age > MAX_AGE) { clearAdminAccess(); return false; }
      showAdmin();
      return true;
    } catch (e) {
      return false;
    }
  }

  restoreAdminAccess();

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form || !form.matches || !form.matches('[data-wc-crux-form]')) return;
    const root = form.closest('[data-wc-crux-root]');
    if (!root) return;
    const emailInput = form.querySelector('[data-wc-crux-email]');
    const email = String(emailInput && emailInput.value || '').trim().toLowerCase();
    if (email !== ADMIN_EMAIL) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    saveAdminAccess();
    showAdmin();
  }, true);

  document.addEventListener('click', function (event) {
    const exitButton = event.target.closest && event.target.closest('[data-wc-crux-exit], [data-wc-crux-try-again]');
    if (exitButton) clearAdminAccess();

    const anchor = event.target.closest && event.target.closest('a[href]');
    if (!anchor) return;

    let url;
    try {
      url = new URL(anchor.href, window.location.href);
    } catch (e) {
      return;
    }

    if (url.hostname !== GUIDE_HOST) return;

    const hash = getAccessHash();
    if (!hash) return;

    event.preventDefault();
    url.searchParams.set('wc_access', hash);
    window.location.assign(url.toString());
  }, true);
})();
